<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M7.533 12.35 3.167 7.983l4.366-4.366L8.6 4.683l-3.317 3.3L8.6 11.267 7.533 12.35Zm4.284 0L7.45 7.983l4.367-4.366 1.05 1.066-3.3 3.3 3.3 3.284-1.05 1.083Z"
        />
    </svg>
</template>

<script setup lang="ts">
type DoubleArrowLeftIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<DoubleArrowLeftIconProps>();
</script>
